<template>
  <div class="instruments has-background-white-bis">

    <section class="section">

      <div class="container has-text-centered is-uppercase is-hidden-mobile">
        <h2 class="is-size-4 has-text-weight-semibold mb-5">
          {{ $t('instruments.percussion') }}
        </h2>
      </div>

      <div class="container" v-if="loading">
        <div class="columns is-multiline">
          <div class="column is-half" v-for="i in media" :key="i">
            <div class="media-content">
              <figure class="image is-16by9 skeleton">
                <div class="skeleton-block"></div>
              </figure>
            </div>
          </div>
        </div>
      </div>

      <div class="container" v-if="!loading">
        <div class="columns is-multiline">
          <div class="column is-half" v-for="tag in percussion" :key="tag.slug">
            <router-link :to="{ path: '/instruments/' + tag.slug }">
              <div class="card is-shadowless">
                <div class="card-image">
                  <b-image
                    :src="'/assets/instruments/percussion/webp/'+ tag.slug +'.webp'"
                    :webp-fallback="'/assets/instruments/percussion/'+ tag.slug +'.jpg'"
                    :src-fallback="require('@/assets/no-instruments.jpg')"
                    :alt="tag.name"
                    ratio="is-16by9"
                  >
                  <!-- <b-skeleton
                      class="skeleton-placeholder"
                      slot="placeholder"
                      height="100%"
                  ></b-skeleton> -->
                  </b-image>
                </div>
                <div class="card-content is-overlay" style="background-color: rgba(0,0,0,0.07);">
                  <span class="has-text-grey-dark has-text-weight-semibold is-size-5">
                    {{ tag.trans || tag.name }}
                  </span>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>

      <hr class="my-6" style="border-top:1px solid #000 !important; height:1px !important;">
      <div class="container has-text-centered">
        <h2 class="is-size-5-desktop is-size-6-mobile has-text-weight-semibold pb-5">
          {{ $t('instruments.looking') }}
        </h2>
        <a href="https://musian.tawk.help/" class="button is-outlined mx-1 px-5 my-5 is-black" rel="noreferrer noopener" target="_blank">
          <span class="has-text-weight-semibold">
            {{ $t('instruments.request') }}
          </span>
        </a>
      </div>

    </section>

  </div>
</template>

<script>
import { getTags } from '@/api/api';

export default {
  name: 'Instruments',

  data() {
    return {
      loading: true,
      media: 6,
      percussion: [],
    };
  },

  computed: {

  },

  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      getTags(null, { headers: { locale: this.$i18n.locale } })
        .then((result) => {
          const { data } = result.data;

          this.percussion = data.filter((item) => item.type === 'percussion');

          this.loading = false;
        })
        .catch((err) => { console.error(err); });
    },
  },
};
</script>
